import type { StoreProduct } from '@/utils/platform'

interface MembershipDisplayPriceInput {
  storePriceRequired: boolean
  storeProduct?: Pick<StoreProduct, 'display_price'>
  backendPrice: number
  backendCurrencySymbol?: string
}

export function getMembershipDisplayPrice({
  storePriceRequired,
  storeProduct,
  backendPrice,
  backendCurrencySymbol = '¥',
}: MembershipDisplayPriceInput): string {
  if (storePriceRequired) return storeProduct?.display_price ?? '—'
  return `${backendCurrencySymbol}${backendPrice}`
}

export function shouldShowBackendPriceDetails(
  storePriceRequired: boolean,
): boolean {
  return !storePriceRequired
}
